import React from 'react'

export default function Logo({height=16,className}) {
  return (
    <>
    <img
      alt="Your Company"
      src="https://cncwebworld.com/image/logoicon.png"
      className={`mx-auto w-auto h-${height} ${className}`}
    />
    </>
  )
}
